export const environment = {
  production: true,
  apiUrl: 'https://clickmix.com.br/catalogcommands/api',
  urlPayment: 'https://api.clickmix.com.br/api',
  merchantKeys: '',
};
